import React, { useContext, useCallback, useState, useEffect } from "react";
import app from "./firebaseApp.js";

export const AuthContext = React.createContext();

let loading = true;

export const AuthProvider = ({ children }) => {
  return <AuthInnerProvider>{children}</AuthInnerProvider>;
};

// Suspense is needed.
export const AuthInnerProvider = ({ children }) => {
  
  const [userObject, setUserObject] = useState({user: null, claims: null});

  useEffect(() => {
    async function updateUser(updatedUser) {
      loading = false;
      if (!updatedUser) {
        setUserObject({ user: updatedUser, claims: null } );
      } else {
        const token = await updatedUser.getIdTokenResult(true);
    
        // let newStatus;
        // if (token.claims.paidUser) {
        //   newStatus = "authorized";
        // } else {
        //   newStatus = "admin-authorization-pending";
        // }
    
        setUserObject({
          user: updateUser,
          claims: token.claims
        })
      }
    }

    app.auth().onAuthStateChanged(updateUser);
  }, [])


  const signOut = useCallback(async () => {
    return app.auth().signOut();
  }, []);

  if (loading) {
    return <div/>;
  }

  return (
    <AuthContext.Provider
      value={{
        getCurrentUser: () => userObject.user,
        user: userObject.user,
        claims: userObject.claims,
        signOut,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth() {
  return useContext(AuthContext);
}
